import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';
// import { SessionEffects } from '../../state-controllers/session-controller/store/effects/session.effects';
// import { EffectsModule } from '@ngrx/effects';
// import { Store, StoreModule } from '@ngrx/store';
// import { sessionReducers } from '../../state-controllers/session-controller/store/reducers';
// import { sessionFeatureKey } from '../../state-controllers/session-controller/store/reducers/session.reducers';
// import { SessionStates } from '../../state-controllers/session-controller/store/states';
// import { SessionActions } from '../../state-controllers/session-controller/store/actions';
import { DeveloperToolsComponent } from './developer-tools/developer-tools.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '../../../material.module';
import { RouterModule } from '@angular/router';
import { WebhookComponent } from './webhook/webhook.component';
import { AgGridModule } from 'ag-grid-angular';
import { DeleteRendererComponent } from './webhook/delete-renderer/delete-renderer.component';
import { FeatureVisibilityComponent } from './feature-visibility/feature-visibility.component';
import { FeatureVisibilityTeamsComponent } from './feature-visibility/feature-visibility-teams/feature-visibility-teams.component';

export const settingsAgGridModule = AgGridModule.withComponents(DeleteRendererComponent);

@NgModule({
  declarations: [
    SettingsComponent,
    DeveloperToolsComponent,
    FeatureVisibilityComponent,
    FeatureVisibilityTeamsComponent,
    WebhookComponent,
    DeleteRendererComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    RouterModule,
    settingsAgGridModule
  ],
  exports: [
    SettingsComponent
  ]
})
export class SettingsModule {}
